export default __webpack_public_path__ + "static/media/Chinese .5a2ec8f6.png";